import { render, staticRenderFns } from "./ProductServiceManagement.vue?vue&type=template&id=cb047e04&scoped=true"
import script from "./ProductServiceManagement.vue?vue&type=script&lang=js"
export * from "./ProductServiceManagement.vue?vue&type=script&lang=js"
import style0 from "./ProductServiceManagement.vue?vue&type=style&index=0&id=cb047e04&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb047e04",
  null
  
)

export default component.exports